import {action} from "mobx";
import i18n from "../i18n";
import applicationService from "../services/applicationService";
import appStore from "./appStore";

const unwrap = (resultOfRequest, successKey) => {
    if (resultOfRequest.status !== 200) {
        appStore.openErrorModal({content: resultOfRequest.data.message});
        return false;
    }
    if (successKey) {
        appStore.showSuccessMessage({content: i18n.t(successKey, {ns: "applications"})});
    }
    return resultOfRequest.data;
};

class applicationStore {
    @action getApplicationCounts = async params =>
        unwrap(await applicationService.getApplicationCounts(params));

    @action getApplications = async (type, params) =>
        unwrap(await applicationService.getApplications(type, params));

    @action exportApplications = async (type, params) =>
        unwrap(await applicationService.exportApplications(type, params));

    @action getApplication = async (type, id) =>
        unwrap(await applicationService.getApplication(type, id));

    @action updateApplicationStatus = async (type, id, params) =>
        unwrap(
            await applicationService.updateApplicationStatus(type, id, params),
            "messages.statusUpdated"
        );

    @action addApplicationNote = async (type, id, params) =>
        unwrap(await applicationService.addApplicationNote(type, id, params), "messages.noteAdded");
}

export default new applicationStore();
